import './styles.scss';
import './styles.modules.scss';
import React from 'react';
import { getResizeImageUrl } from '~utils/image';

type PreviewData = {
  src: string;
  thumbnailUrl: string;
  type: 'image' | 'video';
};

type PreviewProps = {
  images: PreviewData[];
  previewImageIndex: number;
  changePreviewImage: (index: number) => void;
};

export const ThumbnailList: React.FC<PreviewProps> = ({
  images,
  previewImageIndex,
  changePreviewImage,
}) => {
  return (
    <div styleName="thumnails-wrapper">
      <div className="d-flex flex-wrap">
        {images.map((data, index) => (
          <div
            key={data.src}
            className={
              'mr-2 mb-2 border' +
              (previewImageIndex === index ? ' border-dark' : ' border-white')
            }
          >
            <a onClick={() => changePreviewImage(index)}>
              {data.type !== 'video' && (
                <img
                  src={getResizeImageUrl(data.thumbnailUrl, 60, 60)}
                  alt="thumbnail"
                  style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain',
                  }}
                />
              )}
              {data.type === 'video' && (
                <video
                  controls={false}
                  controlsList="nodownload"
                  playsInline
                  style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain',
                  }}
                >
                  <source src={`${data.thumbnailUrl}#t=0.001`} />
                </video>
              )}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
